module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-photo-88c20e3c9e9fba9c4627ed61865c6a13.jpg";